import React from 'react'
import { AuthProvider } from './useAuth'
import { UserProvider } from './user'
import { ModalProvider } from '../contexts/ModalContext'
import { AnalyticsFilterProvider } from '../contexts/AnalyticsFilterContext'

// import { UserProvider } from './user';
// import { ThemeProvider } from './theme';
// import { AuthProvider } from './auth';
// import { NotificationProvider } from './notification';

const AppProvider = ({ children }) => {
    return (
        <AuthProvider>
            <ModalProvider>
                <AnalyticsFilterProvider>
                    <UserProvider>{children}</UserProvider>
                </AnalyticsFilterProvider>
            </ModalProvider>
        </AuthProvider>
    )
}

export default AppProvider
